import { useTheme } from "@emotion/react";
import { Alert, AlertTitle } from "@mui/material";
import { useEffect, useState } from "react";

const CustomAlert = ({
  severity,
  message,
  initialopen = true,
  autoHideDuration = 6000,
  onClose,
  title,
  bottom = 20,
  top,
  left = "50%",
  action,
  style,
}) => {
  const theme = useTheme();

  const [open, setOpen] = useState(initialopen);

  useEffect(() => {
    if (open && autoHideDuration > 0) {
      const timer = setTimeout(() => {
        setOpen(false);
        if (onClose) onClose();
      }, autoHideDuration);

      return () => clearTimeout(timer);
    }
  }, [open, autoHideDuration, onClose]);

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  if (!open) return null;
  return (
    <Alert
      severity={severity}
      sx={
        style || {
          m: 2,
          borderRadius: 2,
          width: "auto",
          position: "fixed",
          bottom: bottom,
          top: top,
          left: left,
          transform: "translateX(-50%)",
          zIndex: theme.zIndex.snackbar,
          boxShadow: theme.shadows[6],
        }
      }
      onClose={handleClose}
      action={action}
    >
      {title && <AlertTitle>{title}</AlertTitle>}

      {message}
    </Alert>
  );
};

export default CustomAlert;
